import { render, staticRenderFns } from "./NivelTecnologicoManage.vue?vue&type=template&id=6968033a&scoped=true"
import script from "./NivelTecnologicoManage.vue?vue&type=script&lang=js"
export * from "./NivelTecnologicoManage.vue?vue&type=script&lang=js"
import style0 from "./NivelTecnologicoManage.vue?vue&type=style&index=0&id=6968033a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968033a",
  null
  
)

export default component.exports